// extracted by mini-css-extract-plugin
module.exports =  {"banner":"_93444fe79c--banner--J0dDs","notnow":"_93444fe79c--notnow--bJ2He","icon":"_93444fe79c--icon--MU_JH","buttons":"_93444fe79c--buttons--tc6Uc"};